import { VedraxFileError } from './vedrax-file-error';

export class VedraxFile {
    file?: File;
    error?: VedraxFileError;
}